import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  maxWidth = "max-w-3xl",
}) {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = 'unset';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const modalContent = (
    <div
      className="fixed inset-0 z-[9990] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className={`bg-white rounded-[16px] shadow-2xl w-full ${maxWidth} max-h-[90vh] flex flex-col overflow-hidden border border-acem-border animate-slide-up`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-acem-border bg-acem-surface-container">
          <h3 className="font-title text-xl font-bold text-acem-primary-dark">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-acem-muted hover:text-acem-text text-2xl font-bold leading-none p-1 rounded-full hover:bg-black/5"
            aria-label="Fermer"
          >
            &times;
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          {children}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
